import {buildActions} from './actions';
import {ReduxRequestEpics} from './epics';
import {buildReducer, initialState} from './reducers';
import {validateOptions} from './utils';

/**
 * @param {ReduxRequestOptions} options
 * @constructor
 */
export function ReduxRequest(options) {
  validateOptions(options);

  this.options = options;
  /** @type {ReduxRequestActions} */
  this.actions = buildActions(options);
  this.reducers = buildReducer(this.actions, options);
  this.epics = new ReduxRequestEpics(this.actions, options);
}

ReduxRequest.initialState = initialState;

/**
 * @typedef {Object} ReduxRequestOptions
 * @property {String} prefix
 * @property {Function} getState Retrieve state from root state.
 * @property {Function} [getRequestState] Retrieve the state from the root state to use for the request. Defaults to getState
 * @property {Array<ReduxAction>} [resetActions] Actions will perform the same behavior as reset. Useful for resetting multiple requests at once.
 * @property {AjaxFactory} [requestFactory]
 * @property {Function} buildRequest Build the request from the redux state
 * @property {Function} getResponseStatus Determine if the response is empty or not and return the appropriate status.
 * @property {Boolean} [autoReset=0] Automatically reset the error state after autoReset milliseconds. 0 disables reset.
 * @property {Logger} logger
 * @property {Function} [requestErrorReducer] Custom reducer to transform the error property.
 */



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux-request/index.js